import http from '@/services/rest/rest.service';

import { ISiteEdit } from '@/entities/sites/site-edit.interface';
import { ISite } from '@/entities/sites/site.interface';
import { IPaging } from '@/entities/paging.interface';
import { ISearchBody } from '@/entities/search-body.interface';
import { IUpdateSiteStatus } from '@/entities/sites/update-site-status.enum';
import { IAgentAccountModel } from '@/entities';

export default {
    create(model: ISiteEdit): Promise<number> {
        return http.put(`sites`, model);
    },
    update(id: number, model: ISiteEdit): Promise<number> {
        return http.post(`sites/${id}`, model);
    },
    delete(id: number): Promise<void> {
        return http.delete(`sites/${id}`);
    },
    enableForAllOffices(id: number): Promise<void> {
        return http.post(`sites/${id}/enableForAllOffices`, []);
    },
    list(withSuspended: boolean = false): Promise<ISite[]> {
        let url = 'sites';
        if (withSuspended) {
            url += '?withSuspended=1';
        }
        return http.get(url);
    },
    listAgentSites(agentId: number): Promise<ISite[]> {
        return http.get(`sites/${agentId}/by-agent`);
    },
    listCompanySites(agentId: number): Promise<ISite[]> {
        return http.get(`sites/${agentId}/by-company`);
    },
    listSiteAgents(siteId: number): Promise<IAgentAccountModel[]> {
        return http.get(`sites/${siteId}/agents`);
    },
    search(body: ISearchBody): Promise<IPaging<ISite>> {
        return http.post('sites/search', body);
    },
    updateStatusBatch(ids, model: IUpdateSiteStatus): Promise<ISite[]> {
        return http.post(`sites/status`, { ids, ...model });
    },
    get(id): Promise<ISite> {
        return http.get(`sites/${id}`);
    }
};
